import type { RouteRecordRaw } from 'vue-router';

export const projectsRoute: RouteRecordRaw = {
  path: '/projects',
  name: 'Projects',
  component: () => import('./pages/ProjectsPage.vue'),
  meta: {
    layout: 'main',
    authorize: ({ isGranted }) => isGranted('hv:core:projects:list'),
  },
};

export const projectDetailRoute: RouteRecordRaw = {
  path: '/projects/:id',
  name: 'ProjectDetail',
  component: () => import('./pages/ProjectDetailPage.vue'),
  meta: {
    layout: 'main',
    authorize: ({ isGranted }) => isGranted('hv:core:projects:get'),
  },
};
